import { useState } from 'react'
import { useClickAway } from '@uidotdev/usehooks'
import bg1 from 'assets/images/TriangleBackground.jpg'
import bg2 from 'assets/images/OrangeX.jpg'
import bg3 from 'assets/images/1786x2555.svg'
import { Image } from 'react-bootstrap'
import { colors } from 'style'

const BACKGROUNDS = [
  { name: 'Triangles', src: bg1 },
  { name: 'Circles', src: bg2 },
  { name: 'Placeholder', src: bg3 },
]

export default function BackgroundSelector({
  background,
  onSelectBackground,
  onRemoveBackground,
}) {
  const [isOpen, setIsOpen] = useState(false)

  const clickAwayRef = useClickAway(() => {
    if (isOpen) setIsOpen(false)
  })

  function handleSelect(src) {
    onSelectBackground(src)
    setIsOpen(false)
  }
  function handleRemove(src) {
    onRemoveBackground(src)
    setIsOpen(false)
  }

  return (
    <div
      ref={clickAwayRef}
      style={{ position: 'relative', display: 'inline-block' }}
    >
      <label
        style={{
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        onClick={() => setIsOpen(true)}
      >
        Background Pattern:
        {background ? (
          <Image
            width={80}
            height={80}
            src={background}
            style={{
              marginTop: 8,
              border: `1px solid ${colors.dark6}`,
              borderRadius: 4,
              objectFit: 'cover',
            }}
          />
        ) : (
          <div
            style={{
              marginTop: 8,
              width: 80,
              height: 80,
              backgroundColor: '#fff',
              border: `1px solid ${colors.dark6}`,
              borderRadius: 4,
            }}
          />
        )}
      </label>

      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '110%',
            left: 0,
            background: 'white',
            border: '1px solid #ccc',
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            padding: 8,
            borderRadius: 4,
            zIndex: 1000,
            minWidth: 180,
          }}
        >
          <div
            style={{
              marginBottom: 4,
              cursor: 'pointer',
              padding: 4,
              color: background == null ? '#007bff' : undefined,
              fontWeight: background == null ? 'bold' : undefined,
            }}
            onClick={handleRemove}
          >
            <span role="img" aria-label="No pattern" style={{ marginRight: 8 }}>
              ⬜
            </span>
            None
          </div>
          {BACKGROUNDS.map((bgOption) => (
            <div
              key={bgOption.src}
              style={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                padding: 4,
                borderRadius: 2,
                background: background === bgOption.src ? '#eef6fa' : undefined,
                fontWeight: background === bgOption.src ? 'bold' : undefined,
              }}
              onClick={() => handleSelect(bgOption.src)}
            >
              <Image
                src={bgOption.src}
                width={40}
                height={40}
                style={{
                  marginRight: 8,
                  objectFit: 'cover',
                  borderRadius: 3,
                }}
                alt={bgOption.name}
              />
              <span>{bgOption.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
